import { render } from "./IconAttachment.vue?vue&type=template&id=2a5cb1c1"
import script from "./IconAttachment.vue?vue&type=script&lang=js"
export * from "./IconAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__